<template>
    <div v-if="photoURl" class="image-wrapper">
        <button :disabled="disabledProp" v-if="showDeleteButton" class="delete-button" @click="deleteClickHandler()">
            <img src="@\assets\images\tableDeleteButton.svg" alt="delete" style="width: 24px; height: 24px;">
        </button>
        <button v-if="showDownloadButton" class="download-button" @click="downloadImage()">
            <img src="@/assets/images/download.svg" alt="download">
        </button>
        <img class="modal-photo modal-media" :src="photoURl" alt="download">
    </div>
    <div v-else class="w-100 d-flex align-items-center justify-content-center" style="height: 100%; background-color: var(--light-gray);">
        empty
    </div>
</template>
<script>
export default {
    props: {
        photoURl: {
            type: String,
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        showDownloadButton: {
            type: Boolean,
            default: true,
        },
        showDeleteButton: {
            type: Boolean,
            default: true,
        },
        disabledProp: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        downloadImage(){
            const link = document.createElement('a');
            link.href = this.photoURl;
            link.download = this.name;
            link.click();
            URL.revokeObjectURL(link);
        },
        deleteClickHandler(){
            this.$emit("deleteClick");
        },
    }
}


</script>
<style scoped>
.image-wrapper{
    position: relative;
    max-width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
}
.image-wrapper .download-button{
    position: absolute;
    padding: 5px;
    background-color: #ffffffd1;
    border-radius: 7px;
    right: 3px;
    top: 3px;
}
.image-wrapper .delete-button{
    position: absolute;
    padding: 5px;
    background-color: #ffffffd1;
    border-radius: 7px;
    left: 3px;
    top: 3px;
}
.image-wrapper .modal-photo{
    height: 100%;
    width: 100%;
    object-fit: cover;
}
</style>